import { FORM_ELEMENT } from "./Editor";
import ExposureFlagElement from "./ExposureFlagElement";
import IndustryClassElement from "./IndustryClassElement";
import LabelledElement from "./LabelledElement";
import LayersElement from "./LayersElement";
import NumberElement from "./NumberElement";
import PricingDefaultsElement from "./PricingDefaultsElement";
import ProducerElement from "./ProducerElement";
import SubjectivitiesElement from "./SubjectivitiesElement";
import SummaryElement from "./SummaryElement";
import TextElement from "./TextElement";
import { LoadingButton } from "@mui/lab";
import {
  FormLabel,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";
import FormattedDatePicker from "components/common/FormattedDatePicker";
import UsStatesSelector from "components/common/UsStatesSelector";

const FormElement = ({ form, formData, config, state, onChange }) => {
  const value = config.readOnly ? config.content : formData?.[config.key];

  if (config.type === FORM_ELEMENT.TEXT) {
    return (
      <TextElement
        label={config.label}
        value={value ?? ""}
        onChange={config.readOnly ? null : (e) => onChange(e.target.value)}
        multiline={config.multiline}
      />
    );
  } else if (config.type === FORM_ELEMENT.NUMBER) {
    return (
      <NumberElement
        label={config.label}
        prefix={config.prefix}
        value={value}
        onChange={(value) => onChange(value)}
      />
    );
  } else if (config.type === FORM_ELEMENT.DATE) {
    return (
      <LabelledElement label={config.label}>
        <FormattedDatePicker
          fullWidth={false}
          compact={true}
          onChangeDate={(value) => onChange(value)}
          value={value}
        />
      </LabelledElement>
    );
  } else if (config.type === FORM_ELEMENT.EXPOSURE_FLAG) {
    return (
      <ExposureFlagElement
        type={config.exposureFlag}
        label={config.label}
        value={value}
        onChange={(value) => onChange(value)}
      />
    );
  } else if (config.type === FORM_ELEMENT.SUBMIT_BUTTON) {
    return (
      <LoadingButton
        onClick={() => onChange(null)}
        variant={"contained"}
        disableElevation
        loading={state?.isSubmitting}
        sx={{
          alignSelf: config.align === "right" ? "flex-end" : "flex-start",
        }}
      >
        {config.label}
      </LoadingButton>
    );
  } else if (config.type === FORM_ELEMENT.LABEL) {
    return (
      <FormLabel
        sx={{
          marginBottom: "0.375rem",
          color: "rgba(0, 0, 0, 0.8)",
          fontWeight: "500",
        }}
      >
        {config.label}
      </FormLabel>
    );
  } else if (config.type === FORM_ELEMENT.CHECKBOX) {
    return (
      <FormControlLabel
        control={
          <Checkbox
            checked={value ?? false}
            onChange={(e) => onChange(e.target.checked)}
          />
        }
        label={config.label}
      />
    );
  } else if (config.type === FORM_ELEMENT.SUBJECTIVITIES) {
    return (
      <SubjectivitiesElement data={formData} onChange={(v) => onChange(v)} />
    );
  } else if (config.type === FORM_ELEMENT.CONTENT) {
    return <Typography marginBottom={"1rem"}>{config.content}</Typography>;
  } else if (config.type === FORM_ELEMENT.INDUSTRY_CLASS) {
    return (
      <LabelledElement label={config.label}>
        <IndustryClassElement
          value={value}
          onChange={(v) => onChange(v)}
          placeholder={"Choose an option or type to search"}
        />
      </LabelledElement>
    );
  } else if (config.type === FORM_ELEMENT.LAYERS) {
    return (
      <LayersElement
        label={config.label}
        data={formData}
        onChange={(v) => onChange(v)}
      />
    );
  } else if (config.type === FORM_ELEMENT.PRICING_DEFAULTS) {
    return (
      <PricingDefaultsElement
        label={config.label}
        options={config.options}
        data={formData}
        onChange={(v) => onChange(v)}
      />
    );
  } else if (config.type === FORM_ELEMENT.US_STATE) {
    return (
      <LabelledElement label={config.label}>
        <UsStatesSelector
          compact
          stateId={value}
          onChange={(v) => onChange(v)}
        />
      </LabelledElement>
    );
  } else if (config.type === FORM_ELEMENT.SUMMARY) {
    return (
      <SummaryElement
        form={{
          ...form,
          formData,
        }}
        items={config.items}
      />
    );
  } else if (config.type === FORM_ELEMENT.PRODUCER) {
    return (
      <ProducerElement
        label={config.label}
        value={value}
        onChange={(v) => onChange(v)}
      />
    );
  } else {
    return <span>{`${config.label} (${config.type})`}</span>;
  }
};

export default FormElement;
